import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// components
import Layout from "./Layout";
import MovieLayout from "./MovieLayout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";

// context
import { useUserState } from "../context/UserContext";

// others
import ScrollToTop from "./ScrollToTop";

export default function App () {
  // global
  const { isAuthenticated } = useUserState();

  return (
    <HashRouter>
      <ScrollToTop />
      <Switch>
        <Route exact path='/' render={() => <Redirect to='/movie' />} />
        <Route path='/app' component={Layout} />
        <Route path='/movie' component={MovieLayout} />
        <PublicRoute path='/login' component={Login} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );

  // #######################################################################

  function PrivateRoute ({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute ({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
